import React from 'react'
import {Navigate, Route, Routes } from "react-router-dom";

import NewPannel from './Admin/scenes/newPannel/NewPannel';
import NovoUsuario from 'Admin/scenes/Usuarios/NovoUsuario';
import EditarUsuario from 'Admin/scenes/Usuarios/EditarUsuario';
import CreateClientes from 'Admin/scenes/Clientes/CreateClientes';
import CreateAgendamento from 'Admin/scenes/Agendamentos/CreateAgendamento';
import CreateProfissionais from 'Admin/scenes/Profissionais/CreateProfissional';
import CreateServicosProdutos from 'Admin/scenes/ServicoProdutos/CreateServicosProdutos';
import Configuracoes from 'Admin/scenes/Configuracoes/Configuracoes';
import FinanceiroIndex from 'Admin/scenes/Financeiro/FinanceiroIndex';
import ListProfissionais from 'Admin/scenes/Profissionais/ListProfissionais';
import Agendamentos from 'Admin/scenes/Agendamentos/Agendamentos';
import ListClientes from 'Admin/scenes/Clientes/ListClientes';
import PainelCaixas from 'Admin/scenes/Caixas/PainelCaixas';
import VendasList from 'Admin/scenes/Vendas/VendasList';
import Venda from 'Admin/scenes/Vendas/Venda';
import ListProdutos from 'Admin/scenes/ServicoProdutos/ListProdutos';
import ListServicos from 'Admin/scenes/ServicoProdutos/ListarServicos';
import CadastroServicoProduto from 'Admin/scenes/ServicoProdutos/NovoServicoProduto';


function AdminRoot() {

  return (
        <div>
          <Routes>

            <Route element={<NewPannel />}>
              <Route exact path="/" element={<Navigate to="caixa" replace />} />              
              <Route path="/create/usuario" element={<NovoUsuario />} />

              <Route path="/clientes" element={<ListClientes/>} />
              <Route path="/create/cliente" element={<CreateClientes/>} />

              <Route path="/agendamentos" element={<Agendamentos/>} />
              <Route path="/create/agendamento" element={<CreateAgendamento/>} />
              
              <Route path="/profissionais" element={<ListProfissionais/>} />
              <Route path="/create/profissional" element={<CreateProfissionais/>} />

              <Route path="/produtos" element={<ListProdutos/>} />
              <Route path="/servicos" element={<ListServicos/>} />
              <Route path="/create/servprod" element={<CreateServicosProdutos/>} />
              <Route path="/create/servprod2" element={<CadastroServicoProduto/>} />

              <Route path="/vendas" element={<VendasList/>} />
              <Route path="/create/venda" element={<Venda/>} />

              <Route path="/financeiro/resumo" element={<FinanceiroIndex/>} />
              <Route path="/caixa" element={<PainelCaixas/>} />
              <Route path="/configuracoes" element={<Configuracoes/>} />
              
              <Route path="/edit/usuario/:id" element={<EditarUsuario />} />
              <Route path="/*" element={<Navigate to="/sistema" replace />} />
            </Route>
          </Routes>
    </div>
  );
}

export default AdminRoot;